import {
	scheduleServiceCallForBuyer,
	scheduleServiceCallForSupplier,
} from '../../thunks/work_orders_thunks';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Alert, Button, DatePicker, Form, Modal, Row, Select } from 'antd';
import moment from 'moment';
import * as React from 'react';
import { useState } from 'react';
import OWForm from '../ow_form/OWForm';
import { WORK_ORDERS_CRUD_ACTION_CREATORS } from '../../actions/work_orders_actions';
import { getDisabledDate, getDisabledDateTime, nullSafeGet } from '../../utils/DataAccessUtils';
import { formatDateForLocationTimeZone, wallTimeToUtcIso } from '../../utils/DataFormatterUtils';
import { withUserType } from '../withUserType';
import { ROLE_TYPES } from '../../utils/DataConstants';

export const DATE_FORMAT = 'MMMM D, YYYY h:mm a';

const BuyerScheduleServiceCall = ({
	creating,
	updating,
	createErrors,
	updateErrors,
	workOrder,

	scheduleServiceCall,
}) => {
	const [form] = Form.useForm();
	const [visible, setVisible] = useState(false);
	const onSubmit = (values) => {
		const timeZone =
			values['serviceScheduledAtTimeZone'] || nullSafeGet('location.timeZoneId', workOrder);
		scheduleServiceCall({
			...values,
			serviceScheduledAt: formatDateForLocationTimeZone(values.serviceScheduledAt, timeZone),
			workOrderId: workOrder.id,
			supplierFacilityId: workOrder.supplierFacilityId,
		});
	};
	const location = nullSafeGet('location', workOrder);
	const myTimeZone = moment.tz.guess();
	const locationTimeZone = nullSafeGet('timeZoneId', location);
	const myTimeZoneAbbreviation = moment.tz(new Date(), moment.tz.guess()).format('z');
	const localTimeZoneAbbreviation = moment.tz(new Date(), locationTimeZone).format('z');
	const initialTz = locationTimeZone || myTimeZone;
	const selectedTimeZone = Form.useWatch('serviceScheduledAtTimeZone') || initialTz || myTimeZone;

	return (
		<>
			<Button
				type="primary"
				key="start"
				onClick={() => setVisible(true)}
				style={{ marginRight: 16 }}
			>
				Schedule Work
			</Button>
			<Modal
				visible={visible}
				width={600}
				title={'Schedule Service'}
				okText={'Schedule'}
				onCancel={() => setVisible(false)}
				onOk={form.submit}
				closable={false}
				confirmLoading={creating || updating}
			>
				<OWForm
					form={form}
					layout="vertical"
					preserve={false}
					onFinish={onSubmit}
					actionCreators={WORK_ORDERS_CRUD_ACTION_CREATORS}
				>
					{createErrors.length > 0 ? (
						<Form.Item>
							<Alert message={createErrors.join(' ')} type="error" />
						</Form.Item>
					) : null}
					{updateErrors.length > 0 ? (
						<Form.Item>
							<Alert message={updateErrors.join(' ')} type="error" />
						</Form.Item>
					) : null}
					<Row className={'flex justify-between align-baseline'} align="middle">
						<span style={{ paddingBottom: myTimeZone === locationTimeZone ? 8 : 0 }}>
							{'Scheduled Arrival Time'}
						</span>

						{myTimeZone === locationTimeZone ? (
							// store tz in the form, but nothing visible
							<Form.Item name={'serviceScheduledAtTimeZone'} initialValue={myTimeZone} hidden>
								<input type="hidden" />
							</Form.Item>
						) : (
							<Form.Item
								name={'serviceScheduledAtTimeZone'}
								initialValue={initialTz}
								style={{ marginBottom: 0, paddingBottom: 0 }}
							>
								<Select
									style={{ marginLeft: 8, flex: 0, minWidth: 175, textAlign: 'right' }}
									bordered={false}
									optionLabelProp="label"
								>
									<Select.Option value={myTimeZone} label={`My Time (${myTimeZoneAbbreviation})`}>
										<div>My Time ({myTimeZoneAbbreviation})</div>
									</Select.Option>

									<Select.Option
										value={locationTimeZone}
										label={`Location Time (${localTimeZoneAbbreviation})`}
									>
										<div>Location Time ({localTimeZoneAbbreviation})</div>
									</Select.Option>
								</Select>
							</Form.Item>
						)}
					</Row>
					<Form.Item
						rules={[
							{
								type: 'object',
								required: true,
								message: 'Please select an estimated arrival time.',
							},
							{
								message: 'Service scheduled time must be after the current time.',
								validator: (_, value) => {
									if (!value) return Promise.resolve();

									const serviceScheduledUtcIso = wallTimeToUtcIso(value, selectedTimeZone);
									const serviceScheduledUtc = moment(serviceScheduledUtcIso).utc();

									const nowUtc = moment().utc().subtract(1, 'minute');

									if (serviceScheduledUtc.isBefore(nowUtc)) {
										return Promise.reject(
											new Error('Service scheduled time must be after the current time.')
										);
									}
									return Promise.resolve();
								},
							},
						]}
						initialValue={
							workOrder.serviceScheduledAt ? moment(workOrder.serviceScheduledAt) : undefined
						}
						name={'serviceScheduledAt'}
					>
						<DatePicker
							style={{ width: '100%' }}
							showTime={true}
							format={DATE_FORMAT}
							disabledDate={getDisabledDate(moment(), selectedTimeZone)}
							disabledTime={getDisabledDateTime(moment(), selectedTimeZone)}
						/>
					</Form.Item>
				</OWForm>
			</Modal>
		</>
	);
};

const mapStateToProps = (state, ownProps) => ({
	match: ownProps.match,
	history: ownProps.history,
	companyConfig: state.company_config,

	createErrors: state.buyer_contacts.createErrors,
	updateErrors: state.buyer_contacts.updateErrors,
	creating: state.work_orders.creating,
	updating: state.work_orders.updating,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	scheduleServiceCall: (serviceCall) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? scheduleServiceCallForSupplier(serviceCall)
				: scheduleServiceCallForBuyer(serviceCall)
		),
});

export default withRouter<any, any>(
	withUserType(connect(mapStateToProps, mapDispatchToProps)(BuyerScheduleServiceCall))
);
